// Add no-scroll CSS

const style = document.createElement("style");
style.textContent = `
  body.no-scroll {
    overflow: unset;
  }
`;
document.head.appendChild(style);

function debounce(func, timeout) {
  let timeoutID;
  return function () {
    const scope = this;
    const args = arguments;
    clearTimeout(timeoutID);
    timeoutID = setTimeout(function () {
      func.apply(scope, Array.prototype.slice.call(args));
    }, timeout);
  };
}

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);
    this.querySelector("form").addEventListener(
      "input",
      this.debouncedOnSubmit.bind(this),
    );
    const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
    if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);
  }
  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => {
        FacetFiltersForm.bindPaginationLinks();
      });
    } else {
      FacetFiltersForm.bindPaginationLinks();
    }
  }
  static bindPaginationLinks() {
    const gridContainer = document.getElementById("ProductGridContainer");
    if (!gridContainer) return;
    const links = gridContainer.querySelectorAll(
      ".pagination a, .pagination-wrapper a",
    );
    links.forEach((link) => {
      link.addEventListener("click", (event) => {
        event.preventDefault();
        const href = link.getAttribute("href");
        if (!href) return;
        const searchParams =
          href.indexOf("?") !== -1 ? href.slice(href.indexOf("?") + 1) : "";
        FacetFiltersForm.renderPage(searchParams);
        const containerTop =
          gridContainer.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({ top: containerTop - 100, behavior: "smooth" });
      });
    });
  }
  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }
  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById("ProductCount");
    const countContainerDesktop = document.getElementById(
      "ProductCountDesktop",
    );

    const gridContainer = document.getElementById("ProductGridContainer");
    const collectionElement = gridContainer
      ? gridContainer.querySelector(".collection")
      : null;

    if (collectionElement) {
      collectionElement.classList.add("loading");
    }

    if (countContainer) {
      countContainer.classList.add("loading");
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add("loading");
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;
      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }
  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }
  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }
  static renderProductGridContainer(html) {
    const parsedHtml = new DOMParser().parseFromString(html, "text/html");
    const sourceContainer = parsedHtml.getElementById("ProductGridContainer");
    const targetContainer = document.getElementById("ProductGridContainer");

    if (sourceContainer && targetContainer) {
      targetContainer.innerHTML = sourceContainer.innerHTML;
    } else {
      const sourceGrid = parsedHtml.getElementById("product-grid");
      const targetGrid = document.querySelector(
        "#ProductGridContainer #product-grid",
      );

      // If either side is missing, do nothing to avoid blanking the page
      if (sourceGrid && targetGrid) {
        targetGrid.innerHTML = sourceGrid.innerHTML;
      }
    }
    FacetFiltersForm.bindPaginationLinks();
  }
  static renderProductCount(html) {
    const parsedHtml = new DOMParser().parseFromString(html, "text/html");
    const productCountElement = parsedHtml.getElementById("ProductCount");

    const customCounterElement = parsedHtml.getElementById("CustomPageCounter");
    if (customCounterElement) {
      const customCounter = document.getElementById("CustomPageCounter");
      if (customCounter) {
        customCounter.innerHTML = customCounterElement.innerHTML;
      }
    }

    if (!productCountElement) return;

    const count = productCountElement.innerHTML;
    const container = document.getElementById("ProductCount");
    const containerDesktop = document.getElementById("ProductCountDesktop");

    if (!container) return;

    container.innerHTML = count;
    container.classList.remove("loading");
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove("loading");
    }
  }
  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");
    const facetDetailsElements = parsedHTML.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter",
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined;
      return jsFilter
        ? element.dataset.index === jsFilter.dataset.index
        : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(
      (element) => !matchesIndex(element),
    );
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);
    facetsToRender.forEach((element) => {
      document.querySelector(
        `.js-filter[data-index="${element.dataset.index}"]`,
      ).innerHTML = element.innerHTML;
    });
    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
    if (countsToRender)
      FacetFiltersForm.renderCounts(
        countsToRender,
        event.target.closest(".js-filter"),
      );
  }
  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      ".active-facets-mobile",
      ".active-facets-desktop",
    ];
    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML =
        activeFacetsElement.innerHTML;
    });
    FacetFiltersForm.toggleActiveFacets(false);
  }
  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      ".mobile-facets__open",
      ".mobile-facets__count",
      ".sorting",
    ];
    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML =
        html.querySelector(selector).innerHTML;
    });
    const menuDrawer = document
      .getElementById("FacetFiltersFormMobile")
      ?.closest("menu-drawer");
    if (menuDrawer && typeof menuDrawer.bindEvents === "function") {
      menuDrawer.bindEvents();
      FacetFiltersForm.setupMenuScrollLock(menuDrawer);
    }
  }
  static setupMenuScrollLock(menuDrawer) {
    // Add no-scroll class when menu opens
    menuDrawer.addEventListener("open", () => {
      document.body.classList.add("no-scroll");
    });
    // Remove no-scroll class when menu closes
    menuDrawer.addEventListener("close", () => {
      document.body.classList.remove("no-scroll");
    });
  }
  static renderCounts(source, target) {
    const targetElement = target.querySelector(".facets__selected");
    const sourceElement = source.querySelector(".facets__selected");
    if (sourceElement && targetElement) {
      target.querySelector(".facets__selected").outerHTML =
        source.querySelector(".facets__selected").outerHTML;
    }
  }
  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`,
    );
  }
  static getSections() {
    const grid = document.getElementById("product-grid");
    if (grid && grid.dataset.id) {
      return [{ section: grid.dataset.id }];
    }
    // Fallback: when 0 products match, #product-grid doesn't exist.
    // Use the empty-state container's data-id instead.
    const emptyGrid = document.getElementById("main-collection-product-grid");
    if (emptyGrid && emptyGrid.dataset.id) {
      return [{ section: emptyGrid.dataset.id }];
    }
    return [];
  }
  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest("form"));
    const searchParams = new URLSearchParams(formData);
    for (const [key, value] of Array.from(searchParams.entries())) {
      if (value === "") {
        searchParams.delete(key);
      }
    }
    // Swap price filter values if min > max to ensure correct order
    const minPriceKey = 'filter.v.price.gte';
    const maxPriceKey = 'filter.v.price.lte';
    const minVal = searchParams.get(minPriceKey);
    const maxVal = searchParams.get(maxPriceKey);
    if (minVal && maxVal && Number(minVal) > Number(maxVal)) {
      searchParams.set(minPriceKey, maxVal);
      searchParams.set(maxPriceKey, minVal);
    }
    FacetFiltersForm.renderPage(searchParams.toString(), event);
  }
  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf("?") == -1
        ? ""
        : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf("?") + 1,
          );
    FacetFiltersForm.renderPage(url);
  }
}
FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();
class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("input").forEach((element) => {
      element.addEventListener("change", this.onRangeChange.bind(this));
    });
    this.setMinAndMaxValues();
  }
  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.swapIfNeeded();
    this.setMinAndMaxValues();
  }
  swapIfNeeded() {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (minInput.value !== "" && maxInput.value !== "" && Number(minInput.value) > Number(maxInput.value)) {
      const temp = minInput.value;
      minInput.value = maxInput.value;
      maxInput.value = temp;
    }
  }
  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute("max", maxInput.value);
    if (minInput.value) maxInput.setAttribute("min", minInput.value);
    if (minInput.value === "") maxInput.setAttribute("min", 0);
    if (maxInput.value === "")
      minInput.setAttribute("max", maxInput.getAttribute("max"));
  }
  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute("min"));
    const max = Number(input.getAttribute("max"));
    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}
customElements.define("price-range", PriceRange);
class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelector("a").addEventListener("click", (event) => {
      event.preventDefault();
      const form =
        this.closest("facet-filters-form") ||
        document.querySelector("facet-filters-form");
      form.onActiveFilterClick(event);
    });
  }
}
customElements.define("facet-remove", FacetRemove);

function initFacetDropdowns() {
  function closeAllFacetDropdowns(exceptDisplay) {
    document.querySelectorAll(".facets__display").forEach(function (display) {
      if (display !== exceptDisplay) {
        display.style.display = "none";
      }
    });
    if (!exceptDisplay) {
      const overlay = document.querySelector(".facets__overlay");
      if (overlay) overlay.classList.remove("active");
      document.body.classList.remove("no-scroll");
    }
  }

  document.addEventListener("click", function (event) {
    const summary = event.target.closest(".facets__summary");
    const insideDisplay = event.target.closest(".facets__display");

    if (summary) {
      const disclosure = summary.closest(".facets__disclosure");
      const display = disclosure
        ? disclosure.querySelector(".facets__display")
        : null;
      if (display) {
        const isOpen = display.style.display === "block";
        closeAllFacetDropdowns(isOpen ? null : display);
        display.style.display = isOpen ? "none" : "block";
      }
    } else if (!insideDisplay) {
      closeAllFacetDropdowns();
    }
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      closeAllFacetDropdowns();
    }
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initFacetDropdowns);
} else {
  initFacetDropdowns();
}

